import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
const Header = ({ title, subtitle, titleTestID, subtitleTestID, visible = true, textAlign, titleProps, ...rest }) => {
    if (!visible) {
        return null;
    }
    return (React.createElement(Stack, { paddingHorizontal: "$4", ...rest },
        React.createElement(Text, { testID: titleTestID, textAlign: textAlign, fontSize: "$h1.strong", fontWeight: "$h1.strong", marginTop: "$4", ...titleProps }, title),
        React.createElement(Text, { testID: subtitleTestID, textAlign: textAlign, fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", marginTop: "$4" }, subtitle)));
};
export { Header };
